/* eslint-disable no-unused-vars */
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Palette } from 'config';
// import { subdirectory } from 'utils';
import { Each, MultiSelect, Buttons } from 'components';

export const SelectedAppsSection = ({ value, onDelete, onClearAll }) => {
  const showAppName = useSelector((state) => state.auth.show_app_name);
  return (
    <AppsBox>
      <ButtonBox>
        <Buttons.TertiarySmall onClick={onClearAll}>Clear All</Buttons.TertiarySmall>
      </ButtonBox>
      <Each
        fieldOfIndex=''
        of={value}
        render={(item, index) => {
          const { pba_name, pba_number, pba_id } = item;
          return (
            <MultiSelect.SelectedApp
              // img={`https://cdn.appnext.com/${subdirectory(image_url)}/${image_url}`}
              title={showAppName ? pba_name ?? '' : `App ID: ${pba_number ?? ''}`}
              key={pba_number}
              descrTitle={showAppName ? 'App ID:' : undefined}
              descrSubtitle={showAppName ? pba_number : undefined}
              onDelete={() => onDelete(pba_id)}
            />
          );
        }}
      />
    </AppsBox>
  );
};

const AppsBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  max-height: calc(100% - 58px);
  overflow-y: auto;
  gap: 10px;
  margin: 8px 0 0;
  padding-bottom: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;

const ButtonBox = styled.div`
  width: 100%;
  height: fit-content;
`;
